import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgChartsModule } from 'ng2-charts';
import {FlexLayoutModule} from "ng-flex-layout";
import {RouterModule} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";

@NgModule({
  imports: [
    GoogleMapsModule,
    InfiniteScrollDirective,
    RouterModule,
    LoggerModule.forRoot({
      level: NgxLoggerLevel.TRACE,
      disableConsoleLogging: false
    }),
    TranslatePipe,
  ],
  providers: [NgbActiveModal],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FontAwesomeModule,
    FlexLayoutModule,
    NgSelectModule,
    GoogleMapsModule,
    NgChartsModule,
    TranslatePipe
  ],
})
export class SharedLibsModule {}
